import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { Spinner } from '@/common/components';
import { AppControllerType, AppRoutes } from '@/common/interfaces';

import LoginPage from '@/pages/Auth/Login.page';

export const AuthController: AppControllerType = {
  common: [
    {
      path: AppRoutes.Login,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <LoginPage/>
        </Suspense>
      ),
      breadcrumb: null
    },
    {
      path: '*',
      element: <Navigate to={ AppRoutes.Login }/>
    }
  ],
  drawer: []
};
